export const authzClientId = import.meta.env.MODE === "production" ? "KlkuirtSHRUNvnFYW7i6wgR7BWmM36Qo" : "SvSXgRplc9sHyT9T60d2TgsZW7vkUoMS";
export const authzDomain = import.meta.env.MODE === "production" ? "gpsdataviz.us.auth0.com" : "dev-mvd105iodgo8sop0.us.auth0.com";
export const authzAudience = import.meta.env.MODE === "production" ? "https://api.gpsdataviz.com" : "test-api";

let host = "https://app.gpsdataviz.com";
if (import.meta.env.VITE_AWS_BRANCH != "master"){
    let branch = import.meta.env.VITE_AWS_BRANCH;
    host = `https://${branch}.d1r3na0sh7ucxf.amplifyapp.com`;
}

console.log(import.meta.env)

const redirectHost = import.meta.env.MODE === "production" ? host : "http://localhost:3000";
export const successfulLoginRedirectUrl = redirectHost + "/team-selection";

export const logoutRedirectUrl = redirectHost + "/"

export const authzScope = "openid";

